import * as React from 'react';
import { useState } from 'react';
import { IMaskInput} from 'react-imask';
import { TextField }  from '@mui/material';
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  precision?: number;
}


interface State {
  localValue: string;
}

export default function NumberField({className, style, disabled, error, helperText, id, InputLabelProps, inputRef, InputProps, label, name, placeholder, required, type, margin, currency, onKeyDown, precision, isKeyField, onNumberChange, value}) {
  // We will actually initialize this in the component in the function below, but declare it here so it survives between renders
  const [TextMaskCustom, setTextMaskCustom] = useState(null); 
  if(!precision && currency){
    // If the field is currency and a precision is not specified, we default to 2
    precision = 2
  }


  if(!TextMaskCustom){
    var thousandsSeparator = "";
    if(currency){
      thousandsSeparator = ",";
    }
    const fieldTextMask = React.forwardRef<HTMLElement, CustomProps>(
      function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
          <IMaskInput
            {...other}
            mask={Number}
            scale={precision}
            definitions={{
              '#': /[1-9]/,
            }}
            radix={"."}
            signed={true}
            thousandsSeparator={thousandsSeparator}
            normalizeZeros={false}
            inputRef={ref}
            onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
            // overwrite
          />
        );
      },
    );

    // Set the text mask custom so we don't have to re-create it on every render for this field
    setTextMaskCustom(fieldTextMask)
  }

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    //setLocalValue({localValue});
  };

  const handleBlur = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const localValue = evt.target.value
    if(onNumberChange){
      // This block allows the user to clear out the field
      if(localValue == "") {
        onNumberChange(undefined);
        return 
      }

      try {
        // If this is a number, we can report it up the chain
        var nval = Number(localValue.replace(/[^-\d.]/g, ""))
        if (isNaN(nval)) {
          onNumberChange(undefined);
        } else {
          onNumberChange(nval);
        }
      } catch (e) {
        // So not a number, so send null
        onNumberChange(undefined);
      }
    }
  };


  //If the field has a specific precision, we need to format the value to that precision...this allows us to ALWAYS pass up a number without sacrificing the precision
  let formattedValue = ""
  if(value !== null && value !== undefined && value !== "" ) {
    if (!isNaN(value)) {
      if(precision && precision > 0){
          formattedValue = value.toFixed(precision)
      } else {
          formattedValue = value.toString()
      }
    }
  }

  if(!InputProps){
    InputProps = {}
  }

  if(!InputProps.inputComponent){
    InputProps.inputComponent = TextMaskCustom;
  }
  var autofillString = navigator.userAgent.indexOf("Chrome") > -1 ? "chrome-off" : "off";
  
  return (
      <TextField
        className={className}
        style={style}
        fullWidth
        disabled={disabled}
        error={error}
        helperText={helperText}
        id={id}
        InputLabelProps={InputLabelProps}
        InputProps={InputProps}
        inputProps={{
          autoComplete: autofillString,
        }}
        inputRef={inputRef}
        label={<span>{label}{isKeyField && !required && <i style={{color: "#CD5C5C", marginLeft: 5}} className="fa fa-key"></i>}</span>}
        name={name || id}
        placeholder={placeholder}
        required={required}
        type={type}
        margin={margin}
        value={formattedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={onKeyDown}
      />

  );
}
